$(() => {
   const element = {
       productSearchContainer: $(".product-search-container"),
       productSearchList: $(".product-search-list"),
       inputSearch: $(".input-product-search"),
   };
    let axiosCancelToken;

    const getPictureUrl = (pictures) => {
        if (pictures.length > 0) {
            return `/storage/${pictures[0]}`;
        }

        return '/img/backend/image.png';
    };

    const displaySearchResult = (data) => {
        const length = data.length;
        element.productSearchList.empty();

        if (length === 0) {
            element.productSearchContainer.removeClass('search--has-suggestions');
        } else {
            data.forEach(function (item) {
                element.productSearchList.append(
                    `
                    <li class="suggestions__item">
                         <div class="suggestions__item-image product-image">
                             <div class="product-image__body">
                                 <img class="product-image__img" src="${getPictureUrl(item.pictures)}" alt="Picture">
                             </div>
                         </div>
                         <div class="suggestions__item-info">
                             <a class="suggestions__item-name" href="/shops/view/${item.slug}">${item.name}</a>
                             <div class="suggestions__item-meta">${item.category.name}</div>
                         </div>
                         <div class="suggestions__item-price">${Dinero({ amount: item.price }).toFormat()}</div>
                    </li>
                    `
                );
            });

            element.productSearchContainer.addClass('search--has-suggestions');
        }
    };

    element.inputSearch.keyup(function (e) {
        const value = $(this).val();

        if (value.length < 3) {
            element.productSearchContainer.removeClass('search--has-suggestions');

            return;
        }

        if (axiosCancelToken) {
            axiosCancelToken.cancel();
        }

        axiosCancelToken = axios.CancelToken.source();

       axios.get(`/shops/search?key=${value}`)
           .then((response) => {
                displaySearchResult(response.data);
           }).catch((error) => {
               if (!axios.isCancel(error)) {
                   throw new Error(error);
               }
           });
   }).dblclick(function () {
       element.productResult.hide();
   });
});
